export default __webpack_public_path__ + "static/project1-56f234ac712ef1ece29473a695377002.jpg";